// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CustomerRefundType {
  Customer = "CUSTOMER",
  CustomerPartial = "CUSTOMER_PARTIAL",
}
export default CustomerRefundType;
